import { UPDATE_BRAND, BrandActionTypes, BrandState } from './types';

export function updateBrand(newState: BrandState): BrandActionTypes {
  return {
    type: UPDATE_BRAND,
    payload: newState
  };
}
